import { ActionIcon, Group, Menu, Stack, Text, Tooltip } from '@mantine/core';

import { IconTileView } from '../../../common/atoms/IconTile';
import type { CardActionsGroupViewProps } from './CardActionsGroup.types';

export function CardActionsGroupView({ actions }: CardActionsGroupViewProps) {
  return (
    <Group gap={4} wrap="nowrap">
      {actions.map(({ icon: Icon, label, active, menuItems, menuLabel, ...actionProps }) => {
        const trigger = (
          <Tooltip label={label}>
            <ActionIcon
              variant={active ? 'filled' : 'subtle'}
              color={active ? 'brand' : 'gray'}
              aria-label={label}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ActionIcon's polymorphic `component` prop isn't representable by the non-generic props type
              {...(actionProps as any)}
            >
              <Icon size={16} />
            </ActionIcon>
          </Tooltip>
        );

        if (!menuItems) return <span key={label}>{trigger}</span>;

        return (
          <Menu key={label} position="bottom-end" withArrow shadow="md" width={260}>
            <Menu.Target>{trigger}</Menu.Target>
            <Menu.Dropdown>
              {menuLabel && <Menu.Label>{menuLabel}</Menu.Label>}
              {menuItems.map((item) => (
                <Menu.Item
                  key={item.label}
                  leftSection={<IconTileView icon={item.icon} color={item.color} size="sm" />}
                  onClick={item.onClick}
                >
                  <Stack gap={0}>
                    <Text size="sm" fw={500}>
                      {item.label}
                    </Text>
                    {item.description && (
                      <Text size="xs" c="dimmed">
                        {item.description}
                      </Text>
                    )}
                  </Stack>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        );
      })}
    </Group>
  );
}
